import ConfigurationSummaryConfirmationCardTypeEnum from '../enums/ConfigurationSummaryConfirmationCardTypeEnum.js';
export default class ConfigurationSummaryCardUtility {
    static getSheetBodyTitleText(translations, type) {
        const { confirmationCardAddToShoppingCartSuccess, confirmationCardAddToShoppingListSuccess, addToShoppingCartFailureHeadline } = translations;
        switch (type) {
            case ConfigurationSummaryConfirmationCardTypeEnum.addToCartSuccess:
            case ConfigurationSummaryConfirmationCardTypeEnum.addUnavailabeToCartAndListSuccess:
            case ConfigurationSummaryConfirmationCardTypeEnum.addUnavailabeToCartSuccessAndListFail:
                return confirmationCardAddToShoppingCartSuccess;
            case ConfigurationSummaryConfirmationCardTypeEnum.addToListSuccess:
                return confirmationCardAddToShoppingListSuccess;
            case ConfigurationSummaryConfirmationCardTypeEnum.addUnavailabeToCartFailAndListSuccess:
                return addToShoppingCartFailureHeadline;
            default:
                return '';
        }
    }
}
//# sourceMappingURL=ConfigurationSummaryCardUtility.js.map